import React, { useEffect, useState } from 'react';
import liracrypt from './Liracrypt/liracrypt';
import ApiErrorComp from './ApiErrorComp/ApiErrorComp';
import { LoadingOutlined } from "@ant-design/icons";

import { useLocation } from 'react-router-dom';
import { Button, Col, Modal, Row, notification } from 'antd';
import Scanter from './STORM/Scanter';
import { useSelector } from 'react-redux';
import MultiText from './MultiText';

const RFIDModal = ({
    selectedLid,
    auxFunctions,
    modal,
    closeModal
}) => {
    const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

    const [loading, setLoading] = useState(true);
    const [responseMsg, setResponseMsg] = useState();
    const [selectedButton, setSelectedButton] = useState();
    const urlCode = useSelector(state => state.urlCode);
    const [openModal, setOpenModal] = useState(false);
    const [modalData, setModalData] = useState();
    const { search } = useLocation();

    const closePopup = () => {
        setResponseMsg(null);
        if (closeModal) {
            closeModal();
        } else {
            setOpenModal(false);
        }
    }

    const getData = () => {
        liracrypt.get(auxFunctions?.config?.api, { ...search, ...auxFunctions?.config?.params, lid: selectedLid })
            .then(response => {
                if (response.data) {
                    setModalData(response.data);
                    setLoading(false);
                    if (!openModal) {
                        setOpenModal(true);
                    }
                }

            }).catch(err => {
                ApiErrorComp();
                console.error(err);
            })
    }

    useEffect(() => {
        setLoading(true);
        getData();
    }, []);


    useEffect(() => {
        let interval;
        if (auxFunctions?.config?.interval) {
            interval = setInterval(() => {
                getData();
            }, auxFunctions?.config?.interval)
        };
        return (() => clearInterval(interval))
    }, [auxFunctions?.config?.interval]);


    const finalAction = (action, res) => {
        if (action === "refreshPhantom") {
            notification.success({
                message: res?.data?.message
                    ? res?.data?.message
                    : "Data Modified Successfully !",
            });
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        } else {
            notification.success({
                message: res?.data?.message
                    ? res?.data?.message
                    : "Data Modified Successfully !",
            });
        }
    };

    const onResponse = ({ button, onlyPostSubmitAction, response }) => {
        // setStormResponse(data);
        let btnData = button || selectedButton;
        // if (btnData.buttonProp?.popUpModal && !onlyPostSubmitAction) {
        //     return openPopupModal(btnData);
        // };
        if (!btnData?.buttonProp?.postSubmitAction) {
            return;
        };
        if (btnData?.postSubmitActionProp?.action === "closePopup") {
            if (btnData?.postSubmitActionProp?.delay) {
                setTimeout(() => {
                    closePopup();
                }, btnData?.postSubmitActionProp?.delay)
            } else {
                closePopup();
            };
            return;
        };

        // if (btnData?.postSubmitActionProp?.action === "clearForm") {
        //   form.resetFields();
        //   console.log("resetFields33");
        // }
        // if (btnData?.postSubmitActionProp?.action === "blankPage") {
        //   setStormResponse(null);
        // };
        // if (btnData?.postSubmitActionProp?.action === "reloadStorm") {
        //     return document.getElementById("submitButtonForm").click();
        // }
        if (btnData?.postSubmitActionProp?.action === "newTab") {
            return window.open(`/v02/${urlCode}` + btnData.postSubmitActionProp.route, '_blank');
        };

        if (btnData?.postSubmitActionProp?.action === 'reloadPage') {
            return window.location.reload();
        }
        finalAction(btnData?.postSubmitActionProp?.action, response)
    };


    const onScanterFinish = ({ button, barCode }) => {
        let postData = {
            ...button?.submitFormDataProp.params, resp: {
                "responseMsg": {
                    text: 'Successfull hahahahb',
                    style: {
                        textAlign: 'center',
                        fontSize: 20,
                        color: '#9c9c9c'
                    }
                }

            }
        };
        postData.barCode = barCode;
        //    postData.seldocs = selectedRowData;
        // setBarCode(barCode);
        if (button?.submitFormDataProp?.method === 'POST') {
            liracrypt.post(button?.submitFormDataProp.url, postData).then(response => {
                if (response.data.isSuccess) {
                    setResponseMsg(response.data?.data?.responseMsg)
                    // notification.success({ message: response.data.message });
                    onResponse({ button, response })
                } else {
                    setResponseMsg(response.data?.data?.responseMsg);
                    //  notification.error({ message: response.data.message })
                }

            })
                .catch(err => {
                    notification.error({
                        message: 'Something went wrong'
                    })
                })
        };
        if (button?.submitFormDataProp?.method === 'PATCH') {
            liracrypt.patch(button?.submitFormDataProp.url, postData).then(response => {
                if (response.data.isSuccess) {
                    notification.success({ message: response.data.message });
                    onResponse({ button, response })
                } else {
                    notification.error({ message: response.data.message })
                }
            })
                .catch(err => {
                    notification.error({
                        message: 'Something went wrong'
                    })
                })
        };
    }

    return (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <Modal
                maskClosable={false}
                closable={false}
                width={modalData?.config?.width || "1000px"}
                title={
                    <MultiText data={modalData?.data?.headerData} />
                } open={openModal} footer={
                    <div style={modalData?.data?.footerData?.length ? { borderTop: '1px solid #ffffff' } : undefined}>
                        {
                            responseMsg ?
                                <p style={{ ...responseMsg?.style, marginBottom: 0 }}>{responseMsg?.text}</p> : <></>
                        }
                        <MultiText data={modalData?.data?.footerData} />
                    </div>
                }>
                {
                    loading ?
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignContent: 'center',
                            alignItems: 'center',
                            width: '100%'
                        }}>
                            {antIcon}
                        </div> :
                        <>
                            <MultiText data={modalData?.data?.bodyData} />
                            <div style={{ width: '100%', marginTop: 10 }}>
                                <Scanter
                                    onFinish={onScanterFinish}
                                    postSubmitAction={onResponse}
                                    openPopupModal={() => { }}
                                    button={modalData?.config?.scanter}
                                    setSelectedButton={setSelectedButton}
                                    form={null}
                                    label={modalData?.config?.scanter?.buttonProp?.label}
                                    type={modalData?.config?.scanter?.buttonProp?.type}
                                    disabled={!modalData?.config?.scanter?.buttonProp?.enable}
                                    confirmationPopUp={modalData?.config?.scanter?.buttonProp?.confirmationPopUp ? modalData?.config?.scanter?.confirmationPopUpProp : undefined}
                                    submitFormData={modalData?.config?.scanter?.submitFormDataProp}
                                />
                            </div>
                        </>
                }
            </Modal>
            {/* {
                openModal ?
                    <>
                        <div id="rfid-modal" style={{ width: '50%' }} className="rfid-modal">
                            <div className="ant-modal-content">
                                <div className="ant-modal-header rfid-modal-header">
                                    <span onClick={() => setOpenModal(false)} className="close">&times;</span>
                                    <Row>
                                        {
                                            modalData.data.headerData.map((x, i) => (
                                                <Col key={`rfid-modal-header-${i}`} span={x.colSize} style={x.style}>
                                                    <p style={{ marginBottom: 0 }}>{x.text}</p>
                                                </Col>
                                            ))
                                        }
                                    </Row>
                                </div>
                                <div className="ant-modal-body">
                                    <Row>
                                        {
                                            modalData.data.bodyData.map((x, i) => (
                                                <Col key={`rfid-modal-header-${i}`} span={x.colSize} style={x.style}>
                                                    <p style={{ marginBottom: 0 }}>{x.text}</p>
                                                </Col>
                                            ))
                                        }
                                    </Row>
                                    <div style={{ width: '100%', marginTop: 10 }}>
                                        <Scanter
                                            onFinish={onScanterFinish}
                                            postSubmitAction={onResponse}
                                            openPopupModal={() => { }}
                                            button={modalData.config.scanter}
                                            setSelectedButton={setSelectedButton}
                                            form={null}
                                            label={modalData.config.scanter?.buttonProp?.label}
                                            type={modalData.config.scanter?.buttonProp?.type}
                                            disabled={!modalData.config.scanter?.buttonProp?.enable}
                                            confirmationPopUp={modalData.config.scanter?.buttonProp?.confirmationPopUp ? modalData.config.scanter?.confirmationPopUpProp : undefined}
                                            submitFormData={modalData.config.scanter?.submitFormDataProp}
                                        />
                                    </div>
                                </div>
                                <div className="ant-modal-footer">
                                    <Row>
                                        {
                                            modalData.data.footerData.map((x, i) => (
                                                <Col key={`rfid-modal-header-${i}`} span={x.colSize} style={x.style}>
                                                    <p style={{ marginBottom: 0 }}>{x.text}</p>
                                                </Col>
                                            ))
                                        }
                                    </Row>
                                </div>
                            </div>
                        </div>
                    </> : <></>
            } */}
        </div>
    )
};

export default RFIDModal;